import { Controller } from '@hotwired/stimulus';

/** Open/close per-row “email unlockers” dialog on /admin/tools. */
export default class extends Controller {
  static targets = ['dialog'];

  open(event) {
    event.preventDefault();
    event.stopPropagation();
    this.dialogTarget.showModal();
  }

  close() {
    this.dialogTarget.close();
  }

  stopPropagation(event) {
    event.stopPropagation();
  }

  confirmSend(event) {
    const panel = event.target.closest('.admin-tools__email-dialog-panel');
    const subtitle = panel?.querySelector('.admin-tools__email-dialog-subtitle')?.textContent || '';
    const match = subtitle.match(/(\d[\d,]*)\s+recipient/);
    const count = match ? match[1].replace(/,/g, '') : null;
    const label = count ? `${count} unlocker${count === '1' ? '' : 's'}` : 'unlockers';

    if (!window.confirm(`Send this email to ${label}?`)) {
      event.preventDefault();
    }
  }

  backdropClose(event) {
    if (event.target === this.dialogTarget) {
      this.dialogTarget.close();
    }
  }
}
